// Which products a customer may actually order. Mirrors ORDERABLE_STOCK in
// functions/index.js, which enforces the same rule server-side at /api/checkout.
//
// Orderable: In Stock, Low Stock, Pre-Order.
// Browse-only: Coming Soon, Update on Stocks to Come, Sold Out.

export const ORDERABLE_STOCK = ["in_stock", "low_stock", "pre_order"];

export function isOrderable(product) {
  if (!product) return false;
  if (product.priceTBA) return false; // price not announced yet
  return ORDERABLE_STOCK.includes(product.stockStatus);
}

export function orderCtaLabel(product) {
  if (!product) return "Unavailable";
  if (product.priceTBA) return "Available 2027";
  switch (product.stockStatus) {
    case "sold_out":
      return "Sold Out";
    case "coming_soon":
      return "Coming Soon";
    case "stocks_to_come":
      return "Update on Stocks to Come";
    case "pre_order":
      return "Pre-Order Now";
    default:
      return "Order Now";
  }
}
